import { features } from '!/flags'
import type { Store } from 'effector'

// indicates about enabled or disabled partners program feature
export const $partnersProgramEnabled: Store<boolean> = features.get(
  'partnersProgramEnabled',
  false
)
